import Newsletter from './Newsletter';
const newsletter = document.querySelector('.newsletter');

if (newsletter) {
    Newsletter(newsletter);
}
